export const tripStatus = {
    cancelled: 'CANCELADO',
    finalized: 'FINALIZADO',
    created: 'CREADO',
    inTransit: 'EN TRANSITO'
  };
